export enum ExistingUserStep {
  Index,
  Continue,
  Type,
  Resubmission,
  Full,
}
